module.exports = __webpack_public_path__ + "static/afterclimb_textured-2ad2a20b68fa596e8fc3e741b25701ba.jpg";